import type { ReactNode } from "react";
import { formatNumber } from "../../utils";

interface StatCardProps {
  label: string;
  value: number;
  sub?: ReactNode;
  mutedSub?: boolean;
}

export function StatCard({
  label,
  value,
  sub,
  mutedSub = false,
}: StatCardProps) {
  return (
    <div className="stat-card">
      <div className="stat-lbl">{label}</div>
      <div className="stat-val">{formatNumber(value)}</div>
      {sub && (
        <div className={`stat-sub ${mutedSub ? "muted" : ""}`.trim()}>
          {sub}
        </div>
      )}
    </div>
  );
}
